import { render, staticRenderFns } from "./RewardsTournament.vue?vue&type=template&id=5b5082f3&scoped=true"
import script from "./RewardsTournament.vue?vue&type=script&lang=js"
export * from "./RewardsTournament.vue?vue&type=script&lang=js"
import style0 from "./RewardsTournament.vue?vue&type=style&index=0&id=5b5082f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5082f3",
  null
  
)

export default component.exports